module.exports = __webpack_public_path__ + "static/apple-icon-152x152-c9e0ab681ae34af91cf9da8d3f9161c9.png";